export default "__VITE_ASSET__CHDnxXu7__"